import { useEffect } from 'react';

const numberToLetter = {
  0: 'a',
  1: 'b',
  2: 'c',
  3: 'd',
  4: 'e',
  5: 'f',
  6: 'g',
};

const useHideQuestionParts = (
  currentPartIndex,
  totalParts,
  shouldHideParts,
  isItemLoaded,
) => {
  const handleDisplay = (index, elementName, displayValue) => {
    const elements = document.querySelectorAll(elementName);
    const letter = numberToLetter[index];
    elements.forEach((element) => {
      if (element.textContent.trim().startsWith(`(${letter})`)) {
        element.style.display = displayValue;
      }
    });
  };

  useEffect(() => {
    if (shouldHideParts && isItemLoaded) {
      // Hide all questions part first.
      for (let index = 0; index < totalParts; index++) {
        handleDisplay(index, 'div', 'none');
        handleDisplay(index, 'p', 'none');
      }
      // Show question part based on current index
      if (currentPartIndex >= 0 && currentPartIndex < totalParts) {
        handleDisplay(currentPartIndex, 'div', 'block');
        handleDisplay(currentPartIndex, 'p', 'block');
      }
    }
  }, [currentPartIndex, isItemLoaded]);

  return {};
};

export default useHideQuestionParts;
